export class DocumentDetailDto {
    documentId!: any;
    number!: string;
    phase!: number;
    version!: string;
    includeQAReview!:boolean;
    requestedEffectiveDate!:Date|null;
    includesClientSignature!:boolean;
    isProficiencyQuizSaveButton!:boolean;
}
